<!--
	#################################### ###############################
	########## DEPRECATED ############## # now use movements-list      #
	#################################### ###############################
-->

<ng-container>
	<div class="toolbar">
		<mat-spinner *ngIf="loadingData" color="primary" mode="indeterminate" diameter="25"></mat-spinner>

		<div class="actions">
			<button *ngIf="buttonDownload" mat-icon-button (click)="exportToExcelClickEventHandler()">
				<mat-icon style="color: rgba(0, 0, 0, 0.54)">file_download</mat-icon>
			</button>
			<button class="pull-right" mat-icon-button (click)="dataGrid()">
				<mat-icon style="color: rgba(0, 0, 0, 0.54)">refresh</mat-icon>
			</button>
		</div>
	</div>

	<div class="table-responsive mat-elevation-z2" style="border-radius: 8px !important">
		<table mat-table [dataSource]="dataSource">
			<div *ngFor="let header of headers">
				<div *ngIf="header.column" [matColumnDef]="header.column">
					<!-- NOMBRE DE COLUMNAS, OCULTAS -->
					<th scope="col" style="padding-left: 0px; display: none" mat-header-cell *matHeaderCellDef>
						<div style="display: flex; flex-direction: row; align-items: center">
							<label class="mt-auto mb-auto text-label text-center col-centered" (click)="orderFilter(header.id)">
								{{ header.columnName }}
							</label>
						</div>
					</th>

					<div *ngIf="!header.actions">
						<div *ngIf="!header.icon">
							<td mat-cell *matCellDef="let element">
								<!-- <div *ngIf="header.columnName != 'Importe' && header.column != 'titulo' && header.columnName != 'Fecha'">
									<div *ngIf="element[header.column].length > 50" data-toggle="tooltip"
										data-placement="top">
										<div class="col-auto  td-text-center text-truncate"
											[innerHTML]="element[header.column]">
										</div>
									</div>
									<div *ngIf="header.id == 4">
										<div class="td-text-center" [innerHTML]="element[header.column]"></div>
									</div>
									<div *ngIf="element[header.column].length <= 50 && header.columnName != 'Origen'">
										<div class="td-text-center" [innerHTML]="element[header.column]"></div>
									</div>
								</div> -->

								<!-- CONCEPTO/ENTIDAD/CUIL/CVU -->
								<div *ngIf="header.column === 'titulo'" class="col-auto">
									<div
										class="col-concepto"
										style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start"
									>
										<div *ngIf="header.column === 'titulo'" [innerHTML]="element[header.column]"></div>
										<div
											data-toggle="tooltip"
											data-placement="bottom"
											style="
												display: flex;
												flex-direction: column;
												justify-content: center;
												align-items: flex-start;
												color: #999da1;
											"
										>
											<span>
												CUIT/CUIL:
												{{ element.cuilCuitContraparte ? maskCuit(element.cuilCuitContraparte) : 'No
												especificado' }}
											</span>
											<span> CVU: {{ element.cvuContraparte ? element.cvuContraparte : 'No especificado' }} </span>
										</div>
									</div>
								</div>

								<!-- IMPORTE Y ESTADO -->
								<div
									*ngIf="header.columnName === 'Importe'"
									[ngClass]="getColorImporte(element[header.column])"
									class="col-auto td-text-right margin-right amount"
								>
									<div>${{ element[header.column] }}</div>
									<div>
										<span [ngClass]="setClassEstado(element.estado)">{{ element.estado ? element.estado : 'Sin
											estado' }}</span>
									</div>
								</div>

								<!-- <div *ngIf="header.columnName==''" data-toggle="tooltip" data-placement="top">
                                    <div class="col-auto  td-text-center text-truncate"
                                    [innerHTML]="element[header.column]"></div>
                                </div>
                                
                                <div *ngIf="header.columnName=='Fecha'" data-toggle="tooltip" data-placement="top">
                                    <div class="col-auto  td-text-center text-truncate feha">
                                        <span style="font-weight: bold;">{{ element[header.column] | date: 'd/M/yy'
                                        }}</span><span style="width: 0.25rem;">&nbsp;</span><span>{{
                                            element[header.column] | date:'H:mm' }}&nbsp;hs</span>
                                    </div>
                                </div>

                            </td>
                        </div>
                        <div *ngIf="header.icon">
                            <td mat-cell style="width: 0px;" *matCellDef="let element">
                                <div class="col-auto text-center">
                                    <div class="row">
                                        <div style='padding-right: 0px; margin: auto' data-toggle="tooltip"
                                            data-placement="bottom" [title]="generateTitle(element[header.column], element.billetera)">
                                            <img alt="cargando imagen" [src]="getIcon(element[header.column], element.billetera).iconURL"
                                                height="30px">
                                        </div>
                                    </div>
                                </div> -->
							</td>
						</div>

						<!-- ICONO DE MEDIO DE PAGO -->
						<div *ngIf="header.icon">
							<td mat-cell style="width: 0px" *matCellDef="let element">
								<div class="col-auto text-center">
									<div class="row">
										<div
											style="padding-right: 0px; margin: auto"
											data-toggle="tooltip"
											data-placement="bottom"
											[title]="element[header.column]"
										>
											<img alt="cargando imagen" [src]="getIcon(element[header.column]).iconURL" height="30px" />
										</div>
									</div>
								</div>
							</td>
						</div>
					</div>
					<div *ngIf="header.actions">
						<td mat-cell *matCellDef="let element">
							<div class="col-auto">
								<div class="row ml-1 justify-content-left">
									<div *ngFor="let action of element[header.column]">
										<button *ngIf="action.status" mat-icon-button matSuffix (click)="clickInAction(element, action)">
											<mat-icon color="dark">{{ action.name }}</mat-icon>
										</button>
									</div>
								</div>
							</div>
						</td>
					</div>
				</div>
			</div>
			<tr
				mat-row
				*matRowDef="let row; columns: headersRow"
				class="list-row"
				(click)="clickInAction(row, row['actions'][0])"
			></tr>
		</table>
	</div>
	<mat-toolbar>
		<mat-toolbar-row style="padding: 0px; align-items: unset; background: #ffffff">
			<mat-paginator
				style="width: 100%"
				[length]="lengthData"
				[pageSize]="size"
				[pageSizeOptions]="pageSizeOptions"
				(page)="changePage($event)"
				#paginator
			>
			</mat-paginator>
		</mat-toolbar-row>
	</mat-toolbar>
</ng-container>
